import React from 'react';

import styles from '../../assets/styles/Button.module.scss';

const Button = ({ children, onClick, type = 'primary', customClass, disabled, submit }) => {
  const buttonStyle = `${styles.button} ${
    type === 'primary' ? styles.primary : type === 'text' ? styles.text : styles.default
  } ${disabled && styles.disabled} ${customClass}`;
  return (
    <button type={submit ? 'submit' : 'button'} onClick={onClick} className={buttonStyle}>
      {children}
    </button>
  );
};

export default Button;
